import * as yup from 'yup';

import '@utils/yup/string';
import { FormParam } from '@repositories/new-application';
import { email as emailValidator } from '@utils/validator';

export const defaultValues: FormParam<'personal_identity'> = {
  ktp: '',
  selfieKtp: '',
  nik: '',
  email: '',
  fullname: '',
  dob: '',
  birthPlace: '',
  gender: '',
  lastEducation: '',
  address: '',
  addressProvince: '',
  addressRegency: '',
  addressDistrict: '',
  addressSubdistrict: '',
  addressZipcode: '',
  maritalStatus: '',
  homeStatus: '',
  totalDependent: '',
  primaryPhoneNumber: '',
  secondaryPhoneNumber: '',
  motherMaidenName: '',
};

const schemes: Record<keyof FormParam<'personal_identity'>, unknown> = {
  ktp: yup.string().required('Kolom wajib diisi'),
  selfieKtp: yup.string().required('Kolom wajib diisi'),
  nik: yup.string().required('Kolom wajib diisi'),
  email: yup
    .string()
    .required('Kolom wajib diisi')
    .test(function (value) {
      if (value.length > 100) {
        return this.createError({
          path: this.path,
          message: 'Maksimal 100 karakter',
        });
      }

      return (
        emailValidator(value) ||
        this.createError({
          path: this.path,
          message: 'Mohon masukkan alamat email yang valid',
        })
      );
    })
    .test(function (value) {
      const emailField = document.querySelector('input[data-available-email]');
      if (!emailField) return true;

      if (value.length > 100) {
        return this.createError({
          path: this.path,
          message: 'Maksimal 100 karakter',
        });
      }

      return (
        emailField?.getAttribute('data-available-email') === 'true' ||
        this.createError({ path: this.path, message: 'Email telah terpakai' })
      );
    }),
  fullname: yup
    .string()
    .required('Kolom wajib diisi')
    .min(3, 'Kolom tidak valid')
    .test(function (value) {
      if (value.length > 100)
        return this.createError({
          path: this.path,
          message: 'Maksimal 100 karakter',
        });

      return true;
    }),
  dob: yup
    .string()
    .required('Kolom wajib diisi')
    .checkMinimumDob('Anda harus berumur minimal 18 tahun')
    .checkMaximumDob('Umur maksimal 70 tahun'),
  birthPlace: yup.string().required('Kolom wajib diisi'),
  gender: yup.string().required('Kolom wajib diisi'),
  lastEducation: yup.string().required('Kolom wajib diisi'),
  motherMaidenName: yup
    .string()
    .required('Kolom wajib diisi')
    .min(3, 'Kolom tidak valid'),
  address: yup
    .string()
    .required('Kolom wajib diisi')
    .test(function (value) {
      return value.length > 100
        ? this.createError({
            path: this.path,
            message: 'Maksimal 100 karakter',
          })
        : true;
    }),
  addressProvince: yup.string().required('Kolom wajib diisi'),
  addressRegency: yup.string().required('Kolom wajib diisi'),
  addressDistrict: yup.string().required('Kolom wajib diisi'),
  addressSubdistrict: yup.string().required('Kolom wajib diisi'),
  addressZipcode: yup
    .string()
    .required('Kolom wajib diisi')
    .test(function (value) {
      return (
        /^[0-9]{5}$/.test(value) ||
        this.createError({ path: this.path, message: 'Kode pos tidak valid' })
      );
    }),
  totalDependent: yup.string().required('Kolom wajib diisi'),
  maritalStatus: yup.string().required('Kolom wajib diisi'),
  homeStatus: yup.string().required('Kolom wajib diisi'),
  primaryPhoneNumber: yup.string().required('Kolom wajib diisi'),
  secondaryPhoneNumber: yup
    .string()
    .checkPhoneNumber('Nomor telepon tidak valid'),
};

export const personalIdentitySchema =
  yup.object<FormParam<'personal_identity'>>(schemes);
